import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';
import { ApuracaoRenunciaDto } from 'src/app/model/renuncia.model';
import { CicloDistribuicaoDto } from 'src/app/model/ciclo-distribuicao-dto.model';
import { ResultadoPaginado } from "src/app/model/resultado";


@Injectable({
  providedIn: 'root'
})
export class DistribuicaoLimitesService extends FgiBackEndService<CicloDistribuicaoDto>{

  getNewEntity() {
    return new CicloDistribuicaoDto;
  }

  protected getResourceURL(): string {
    return 'front/distribuicao-limites';
  }

  public iniciarPrimeiroCicloDistribuicaoLimites(): Observable<MensagemRetornoAssincrono> {
    return this.http.get<MensagemRetornoAssincrono>(`${this.BASE_URL}/iniciar-ciclo-1`).pipe
      (catchError((e) => this.handleError(e)));
  }

  public executarPreviaDistribuicaoLimites(valorTotalNovoLimiteContratacao: number): Observable<MensagemRetornoAssincrono> {
    return this.http.get<MensagemRetornoAssincrono>(`${this.BASE_URL}/executar-previa/${valorTotalNovoLimiteContratacao}`).pipe
      (catchError((e) => this.handleError(e)));
  }

  public executarDistribuicaoLimites(): Observable<MensagemRetornoAssincrono> {
    return this.http.get<MensagemRetornoAssincrono>(`${this.BASE_URL}/executar-distribuicao`).pipe
      (catchError((e) => this.handleError(e)));
  }

  public totalPorModalidade(): Observable<ApuracaoRenunciaDto> {
    return this.http.get<ApuracaoRenunciaDto>(`${this.BASE_URL}/total-por-modalidade`).pipe
      (catchError((e) => this.handleError(e)));
  }

  public buscarCiclosPaginados(params: any): Observable<ResultadoPaginado<CicloDistribuicaoDto>> {
    const options: object = blockUi({ params });
    return this.http.get<ResultadoPaginado<CicloDistribuicaoDto>>(`${this.BASE_URL}`, options).pipe
      (catchError((e) => this.handleError(e)));
  }

  public reverterCicloPorId(id: number): Observable<MensagemRetornoAssincrono> {
    const options: object = blockUi();
    return this.http.post<MensagemRetornoAssincrono>(`${this.BASE_URL}/${id}/reverter-ciclo`, {}, options).pipe
      (catchError((e) => this.handleError(e))) as unknown as Observable<MensagemRetornoAssincrono>;
  }
  
}
